document.addEventListener('alpine:init', () => {
    Alpine.data('countdownElement', () => ({
        beforeRow: null,
        afterRow: null,
        targetTimestamp: 0,
        intervalId: null,
        hasTarget: false,
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00',
        init() {
            this.beforeRow = this.$refs.beforeRow || null;
            this.afterRow = this.$refs.afterRow || null;
            this.targetTimestamp = parseInt(this.$el.dataset.countdownAt || '0', 10);
            this.hasTarget = this.targetTimestamp > 0;
            this.updateCountdown();
            this.intervalId = window.setInterval(() => this.updateCountdown(), 1000);
        },
        destroy() {
            if (this.intervalId) {
                window.clearInterval(this.intervalId);
            }
        },
        updateCountdown() {
            const now = Math.floor(Date.now() / 1000);
            const showAfter = this.targetTimestamp > 0 && now >= this.targetTimestamp;
            const remaining = this.targetTimestamp > 0 ? Math.max(0, this.targetTimestamp - now) : 0;

            this.days = this.padValue(Math.floor(remaining / 86400));
            this.hours = this.padValue(Math.floor((remaining % 86400) / 3600));
            this.minutes = this.padValue(Math.floor((remaining % 3600) / 60));
            this.seconds = this.padValue(remaining % 60);

            if (this.beforeRow) {
                this.beforeRow.hidden = showAfter;
            }
            if (this.afterRow) {
                this.afterRow.hidden = !showAfter;
            }
        },
        padValue(value) {
            return String(value).padStart(2, '0');
        },
        digits(value) {
            return String(value).split('');
        },
    }));
});
